import React from "react";
import { Text } from "@salestrak/ui";
import { EntityTag } from "#app/components/entity";
import type {
  ActivityChange,
  ActivityStageInfo,
  ActivityWorkflowInfo,
} from "../activity-types";
import { DEFAULT_ISSUE_NAME } from "../activity-types";

interface StageChangeChunkProps {
  change: ActivityChange;
}

function StageRef({
  connector,
  stage,
  workflow,
  crossWorkflow,
}: {
  connector: string;
  stage: ActivityStageInfo;
  workflow: ActivityWorkflowInfo | null | undefined;
  crossWorkflow: boolean;
}) {
  return (
    <Text size="sm">
      {" "}
      {connector}
      {crossWorkflow && workflow ? (
        <Text size="sm">
          {" "}
          <EntityTag
            entity={{
              kind: "workflow",
              id: workflow.workflowId,
              workflow,
            }}
            display="label"
            weight="semibold"
            as="text"
          />
          {" › "}
        </Text>
      ) : null}
      {" "}
      <EntityTag
        entity={{
          kind: "stage",
          id: stage.stageId,
          stage,
          workflowId: stage.workflowId ?? undefined,
        }}
        display="label"
        weight="semibold"
        as="text"
      />
    </Text>
  );
}

export function StageChangeChunk({ change }: StageChangeChunkProps) {
  const oldStage = change.oldValue?.stage;
  const newStage = change.newValue?.stage;
  const oldWorkflow = change.oldValue?.workflow;
  const newWorkflow = change.newValue?.workflow;
  const crossWorkflow = !!(
    oldWorkflow &&
    newWorkflow &&
    oldWorkflow.workflowId !== newWorkflow.workflowId
  );

  return (
    <Text size="sm">
      moved this {DEFAULT_ISSUE_NAME.toLowerCase()}
      {oldStage && newStage ? (
        <StageRef
          connector="from"
          stage={oldStage}
          workflow={oldWorkflow}
          crossWorkflow={crossWorkflow}
        />
      ) : null}
      {newStage ? (
        <StageRef
          connector="to"
          stage={newStage}
          workflow={newWorkflow}
          crossWorkflow={crossWorkflow}
        />
      ) : null}
    </Text>
  );
}
